
import { useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import PortfolioSection from './components/PortfolioSection';
import ReviewsSection from './components/ReviewsSection';
import ContactSection from './components/ContactSection';
import Footer from '../../components/feature/Footer';

export default function Home() {
  useEffect(() => {
    // Add Schema.org JSON-LD for homepage
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Terra Landscape & Design",
      "description": "Premium landscape construction company specializing in 3D design renderings and luxury outdoor living projects in Seattle and surrounding areas.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
      "telephone": "+1-206-555-0123",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "123 Garden Way",
        "addressLocality": "Seattle",
        "addressRegion": "WA",
        "postalCode": "98101",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 47.6062,
        "longitude": -122.3321
      },
      "openingHours": [
        "Mo-Fr 08:00-18:00",
        "Sa 09:00-16:00"
      ],
      "serviceArea": {
        "@type": "GeoCircle",
        "geoMidpoint": {
          "@type": "GeoCoordinates",
          "latitude": 47.6062,
          "longitude": -122.3321
        },
        "geoRadius": "50000"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Landscape Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "3D Design & Rendering",
              "description": "Professional 3D landscape design and visualization services"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Landscape Construction",
              "description": "Complete landscape construction and installation services"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Outdoor Living Spaces",
              "description": "Custom outdoor living space design and construction"
            }
          }
        ]
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "reviewCount": "127"
      }
    });
    document.head.appendChild(script);

    // Add FAQ Schema
    const faqScript = document.createElement('script');
    faqScript.type = 'application/ld+json';
    faqScript.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What services does Terra Landscape & Design offer?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We offer comprehensive landscape design and construction services including 3D design renderings, outdoor living spaces, garden construction, and complete landscape transformation projects in Seattle and surrounding areas."
          }
        },
        {
          "@type": "Question",
          "name": "Do you provide 3D design renderings?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, we specialize in professional 3D design renderings that help you visualize your outdoor space before construction begins. This ensures you're completely satisfied with the design before we break ground."
          }
        },
        {
          "@type": "Question",
          "name": "What areas do you serve?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We serve Seattle and the surrounding areas within a 50-mile radius, providing premium landscape construction and design services to residential and commercial clients."
          }
        }
      ]
    });
    document.head.appendChild(faqScript);

    return () => {
      // Cleanup scripts on unmount
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => script.remove());
    };
  }, []);

  return (
    <div className="min-h-screen">
      <header>
        <h1 style={{ position: 'absolute', left: '-9999px' }}>Terra Landscape & Design</h1>
      </header>
      <main>
        <Navigation />
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <PortfolioSection />
        <ReviewsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}